<div class="px-4 pb-4">
  <div>
    <div
      *ngFor="let pair of controls(); let i = index; trackBy: trackByIndex"
      [formGroup]="pair.group"
      class="mb-3"
    >
      <div>
        <span>{{ pair.key + ":" }}</span>
        <div class="px-4">
          <app-validated-input
            [label]="('admin.common.details.code' | translate) + ':'"
            inputFormControlName="code"
            [inputFormControl]="pair.group.controls.localizedName"
            [validationTrainslations]="{
              required: 'validation.required'
            }"
          >
          </app-validated-input>
          <app-validated-input
            [label]="('admin.common.details.shortForm' | translate) + ':'"
            inputFormControlName="shortForm"
            [inputFormControl]="pair.group.controls.localizedTypeName"
            [validationTrainslations]="{
              required: 'validation.required'
            }"
          >
          </app-validated-input>
        </div>
      </div>
    </div>
  </div>

  @if (showButtons()) {
  <div class="d-flex justify-content-end gap-2 px-4 py-4">
    <app-button
      [label]="'general.cancel' | translate"
      variant="default"
      (clicked)="cancel()"
    />
    <app-button
      [iconClass]="'fas fa-save'"
      [label]="'general.save' | translate"
      btnClass="btn btn-primary btn-sm action-btn"
      (clicked)="save()"
      [disabled]="disableSave()"
    />
  </div>
  }
</div>
